module.exports = __webpack_public_path__ + "img/et.2761ffc9.svg";